import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {animated, useSpring} from 'react-spring';
import {LayerContext} from '../../services/layer/layer.context';
import {Spinner} from '../spinner/spinner';
import './bike-layer-info-component.scss';
import CloseBikeNetworkInfo from '../../components/buttons/closeBikeNetworkInfo-button/closeBikeNetworkInfo-button';
import {isMobile} from 'react-device-detect';
import {ReactComponent as CyclePath} from '../../assets/icons/bike-layer/cyclePath.svg';
import {ReactComponent as PacifiedRoad} from '../../assets/icons/bike-layer/pacifiedRoad.svg';
import {ReactComponent as GreenRoad} from '../../assets/icons/bike-layer/greenRoad.svg';
import {ReactComponent as LaneThirty} from '../../assets/icons/bike-layer/lane30.svg';


export function BikeLayerInfo() {
    const {t} = useTranslation();
    const LayerCtx = useContext(LayerContext);
    const isOpen = LayerCtx.visible;
    const [infoVisible, setInfoVisible] = useState(true);

    const handleClose = () => {
        setInfoVisible(false);
        LayerCtx.toggleVisibleBikeLayer(false);
    };

    const infoVisibility = () => {
        if (isMobile) {
            if (!infoVisible) {
                return 'bikeLayerInfo-container-hide';
            }
            if (LayerCtx.bikeLayerVisible) {
                return 'bikeLayerInfo-container bikelayer-mobile';
            }
        }
        if (!infoVisible) {
            return 'bikeLayerInfo-container-hide';
        }


        if (LayerCtx.bikeLayerVisible) {
            return 'bikeLayerInfo-container';
        }

        return 'bikeLayerInfo-container-hide';
    };

    useEffect(() => {
        if (LayerCtx.bikeLayerVisible) {
            setInfoVisible(true);
        }
    }, [LayerCtx.bikeLayerVisible]);

    const bikeLayerTypes = [
        {'title': t('cyclable_network_bike_lane'), 'icon': CyclePath, 'color': 'red'},
        {'title': t('cyclable_network_pacified_road'), 'icon': PacifiedRoad, 'color': 'orange'},
        {'title': t('cyclable_network_green_road'), 'icon': GreenRoad, 'color': 'green'},
        {'title': t('cyclable_network_lanes_thirty'), 'icon': LaneThirty, 'color': 'cyan'},
    ];

    const {
        right,
        opacity,
    } = useSpring({
        from: {
            right: '29px',
            backgroundColor: '#ffffff',
            opacity: 1,
        },
        right: isOpen ? '85px' : '40px',
        color: isOpen ? '#da322a' : '#ffffff',
        opacity: isOpen ? 1 : 0,
    });


    return (
        <>
            {LayerCtx.bikeLayerVisible && (
                <>
                    {isMobile && (
                        <div
                            className="bikelayer-overlay"
                            role="button"
                            tabIndex={0}
                            onClick={handleClose}
                            onKeyDown={handleClose}
                            style={{background: 'rgba(0, 0, 0, 0.5)'}}
                        />
                    )}
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className={LayerCtx.bikeLayerVisible ? 'bikeLayerInfo-show' : 'bikeLayerInfo-hide'}
                        role="button"
                        onKeyDown={handleClose}
                        tabIndex={0}
                    >
                        <animated.div style={{right}}>
                            <animated.div style={{opacity}}>
                                <div className={infoVisibility()}>
                                    <div className="bikeLayerInfo-header">
                                        <h1>{t('translation:cyclable_network')}</h1>
                                    </div>
                                    <div className="bikeLayerInfo-list">
                                        {bikeLayerTypes.map((layer, i) => (
                                            <div className="bikeLayer-item" key={i}>
                                                <div className={`icon-container-${layer.color}`}>
                                                    <layer.icon />
                                                </div>
                                                <span className="transport-name">{layer.title}</span>
                                            </div>
                                        ))}
                                    </div>
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        onClick={handleClose}
                                        onKeyDown={handleClose}
                                        className="bikelayer-close-div"
                                    >
                                        <CloseBikeNetworkInfo title={t('app_drawer_close')} />
                                    </div>
                                </div>
                            </animated.div>
                            <Spinner />
                        </animated.div>
                    </div>
                </>
            )}
        </>
    );
}
export default BikeLayerInfo;
